// @flow

import { retailCollectionsActions } from './retailCollectionsActionCreator';

const filterTableDataHandoverStatus = (
  preFilteredData,
  handoverStatusSelectedOption
) => {
  const searchString = handoverStatusSelectedOption.trim();

  let filteredArr;

  if (searchString) {
    filteredArr = preFilteredData.filter(
      row => row.handoverStatus && row.handoverStatus === searchString
    );
  } else {
    filteredArr = preFilteredData;
  }

  return filteredArr;
};

const filterTableDataPaymentMode = (
  preFilteredData,
  paymentModeSelectedOption
) => {
  const searchString = paymentModeSelectedOption.toLowerCase().trim();

  let filteredArr;

  if (searchString) {
    filteredArr = preFilteredData.filter(
      row =>
        row.paymentType &&
        row.paymentType.toLowerCase().indexOf(searchString) >= 0
    );
  } else {
    filteredArr = preFilteredData;
  }

  return filteredArr;
};

const filterTableDataCollectedBy = (
  preFilteredData,
  collectedBySelectedOption
) => {
  const searchString = collectedBySelectedOption.toLowerCase().trim();

  let filteredArr;

  if (searchString) {
    filteredArr = preFilteredData.filter(
      row =>
        row.collectUserName &&
        row.collectUserName.toLowerCase().indexOf(searchString) >= 0
    );
  } else {
    filteredArr = preFilteredData;
  }

  return filteredArr;
};

const filterTableData = (newState, filterObj) => {
  let filteredArr;
  let handoverStatusFilteredArr;
  let paymentModefilteredArr;
  let collectedByfilteredArr;

  if (filterObj.handoverStatusSelectedOption) {
    handoverStatusFilteredArr = filterTableDataHandoverStatus(
      newState.tableData,
      filterObj.handoverStatusSelectedOption
    );
  } else {
    handoverStatusFilteredArr = newState.tableData;
  }

  if (filterObj.paymentModeSelectedOption) {
    paymentModefilteredArr = filterTableDataPaymentMode(
      handoverStatusFilteredArr,
      filterObj.paymentModeSelectedOption
    );
  } else {
    paymentModefilteredArr = handoverStatusFilteredArr;
  }

  if (filterObj.collectedBySelectedOption) {
    collectedByfilteredArr = filterTableDataCollectedBy(
      paymentModefilteredArr,
      filterObj.collectedBySelectedOption
    );
  } else {
    collectedByfilteredArr = paymentModefilteredArr;
  }

  if (filterObj.searchString) {
    const searchString = filterObj.searchString.toLowerCase().trim();
    filteredArr = collectedByfilteredArr.filter(
      row =>
        (row.cnote && row.cnote.toLowerCase().indexOf(searchString) >= 0) ||
        (row.clientName &&
          row.clientName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.clientNumber &&
          row.clientNumber.toLowerCase().indexOf(searchString) >= 0) ||
        (row.handoverTransactionId &&
          row.handoverTransactionId.toLowerCase().indexOf(searchString) >= 0) ||
        (row.handoverRecieverName &&
          row.handoverRecieverName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.collectUserName &&
          row.collectUserName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.collectUserMobile &&
          row.collectUserMobile.toLowerCase().indexOf(searchString) >= 0) ||
        (row.paymentType &&
          row.paymentType.toLowerCase().indexOf(searchString) >= 0) ||
        (row.bankName &&
          row.bankName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.chequeNumber &&
          row.chequeNumber.toLowerCase().indexOf(searchString) >= 0)
    );
  } else {
    filteredArr = collectedByfilteredArr;
  }

  return filteredArr;
};

const initialState = {
  isLoading: false,
  isLoaded: false,
  tableData: null,
  tableDataFiltered: [],
  filterValues: {},
  tdsApplicableData: {
    data: { status: null, val: null }
  },
  editPaymentModalData: {
    isLoading: false,
    isLoaded: false,
    preventResetData: false,
    data: { status: null, val: null }
  },
  bankDetailsData: {
    isLoading: true,
    isLoaded: false,
    data: { status: null, val: null }
  },
  allowedPaymentTypes: {
    isLoading: true,
    isLoaded: false,
    data: { status: null, val: null }
  },
  shortPaymentReasons: {
    isLoading: true,
    isLoaded: false,
    data: { status: null, val: null }
  }
};

const retailCollectionsReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case retailCollectionsActions.GET_COLLECTIONS_SUMMARY: {
      return Object.assign({}, state, action.payload);
    }
    case retailCollectionsActions.FILTER_COLLECTIONS_SUMMARY_TABLE_DATA: {
      const newState = Object.assign({}, state);
      const filteredData = filterTableData(newState, action.payload);
      return Object.assign({}, state, { tableDataFiltered: filteredData });
    }
    case retailCollectionsActions.TDS_APPLICABLE: {
      return Object.assign({}, state, action.payload);
    }
    case retailCollectionsActions.SET_RTL_COLLECTIONS_DATE_FILTER: {
      return Object.assign({}, state, {
        filterValues: {
          ...state.filterValues,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      });
    }
    case retailCollectionsActions.SET_LOCATION_FILTER_VALUE: {
      return Object.assign({}, state, {
        filterValues: {
          ...state.filterValues,
          locationId: action.payload.locationId
        }
      });
    }
    case retailCollectionsActions.EDIT_PAYMENT_DETAILS: {
      return Object.assign({}, state, action.payload);
    }
    case retailCollectionsActions.GET_BANK_DETAILS: {
      return Object.assign({}, state, action.payload);
    }
    case retailCollectionsActions.GET_RIVIGO_BANK_DETAILS: {
      return Object.assign({}, state, action.payload);
    }
    case retailCollectionsActions.GET_ALLOWED_PAYMENT_TYPES: {
      return Object.assign({}, state, action.payload);
    }
    case retailCollectionsActions.GET_SHORT_PAYMENT_REASONS: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default retailCollectionsReducer;
